const UserActionTypes = {
  ADD_USER: "ADD_USER",
  GET_USER: "GET_USER",
  STATUS_USER: "STATUS_USER",
  CLEAR_USER:  "CLEAR_USER",
};

export default UserActionTypes;
